import { c as _c } from "react/compiler-runtime";
import { useTourSearchWrapper } from "@website/accommodation-ui/tour-search-box/hooks";
import { TourSearchToggle } from "@website/accommodation-ui/tour-search-box/tour-search-toggle";
import { TourSearchWrapperPropertiesType } from "@website/accommodation-ui/tour-search-box/types";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { SearchSummary } from "@website/widget/search-summary";
import { SearchSummaryGroup } from "@website/widget/search-summary-group";
import { useRouter } from "next/router";
import { FC } from "react";
export const TourSearchBox: FC<TourSearchWrapperPropertiesType> = properties => {
  const $ = _c(29);
  const {
    searchSummaryProperties,
    searchPanelProperties
  } = properties;
  const {
    isSearchPanelOpen,
    handleClose,
    handleOpen
  } = useTourSearchWrapper();
  const {
    pathname
  } = useRouter();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname.includes("group");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isGroup = t0;
  const {
    isMobile,
    isTablet
  } = useViewPort();
  const t1 = `top-0 z-20 bg-white ${(isMobile || isTablet) && isSearchPanelOpen ? "!static" : "!sticky"} `;
  let t2;
  if ($[2] !== handleOpen || $[3] !== isGroup || $[4] !== searchSummaryProperties) {
    t2 = <div className="flex justify-center px-6 py-2 md:py-4">{isGroup ? <SearchSummaryGroup {...searchSummaryProperties} onClick={handleOpen} /> : <SearchSummary tripType="" {...searchSummaryProperties} onClick={handleOpen} />}</div>;
    $[2] = handleOpen;
    $[3] = isGroup;
    $[4] = searchSummaryProperties;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `absolute top-0 z-30 max-h-0 w-full overflow-hidden bg-white transition-all duration-500 max-lg:h-0 ${isSearchPanelOpen ? "h-auto max-h-screen overflow-visible max-lg:!h-[calc(100svh-64px)]" : ""} ${isMobile || isTablet ? "!fixed !inset-y-0 !h-screen max-lg:!h-screen" : ""} `;
  const t4 = `mx-auto size-full pb-6 pt-4 opacity-0 transition-all duration-500 xl:pb-10 xl:pt-6 ${isSearchPanelOpen ? "opacity-100" : ""}`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MaterialIcon name="close" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleClose) {
    t6 = <div className="px-4 pb-3 md:hidden"><Button StartIcon={t5} color="neutral" onClick={handleClose} size="small" variant="text" /></div>;
    $[7] = handleClose;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleClose || $[10] !== searchPanelProperties) {
    t7 = <TourSearchToggle {...searchPanelProperties} onClose={handleClose} />;
    $[9] = handleClose;
    $[10] = searchPanelProperties;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t6 || $[14] !== t7) {
    t8 = <div className={t4}>{t6}{t7}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <section className={t3}>{t8}</section>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t9) {
    t10 = <div className={t1}>{t2}{t9}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = `bg-gray fixed right-0 top-0 z-10 h-screen w-screen opacity-40 ${isSearchPanelOpen ? "block" : "hidden"}`;
  let t12;
  if ($[23] !== handleClose || $[24] !== t11) {
    t12 = <button className={t11} onClick={handleClose} type="button" />;
    $[23] = handleClose;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};